import { useMemo } from 'react';
import GalleryImageType from '~/constants/vdp/galleryImageType';
import { GalleryImage } from '~/contracts/vdp';
import { getSafetyFeatures, getSpinnerData } from '~/selectors';
import useSelector from '~/store/useSelector';
import {
  transformExteriorImages,
  transformFeatures,
  transformImperfections
} from '~/transform/imagery';

type Options = {
  includeSafetyFeatures: boolean;
};

export default function useGalleryImages({
  includeSafetyFeatures
}: Options): GalleryImage[] {
  const {
    features: featuresRaw = [],
    imperfections: imperfectionsRaw = [],
    spins = []
  } = useSelector(getSpinnerData);
  const safetyFeatures = useSelector(getSafetyFeatures);

  return useMemo<GalleryImage[]>(() => {
    const featureImages = transformFeatures(featuresRaw);
    const imperfectionImages = transformImperfections(imperfectionsRaw);
    const exteriorImages = transformExteriorImages(spins);
    const safetyFeatureImages = includeSafetyFeatures
      ? safetyFeatures.map<GalleryImage>((v, index) => ({
          id: `safety-${index}`,
          imageUrl: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/${v.facetName}.jpg`,
          location: null,
          title: v.facetName,
          type: GalleryImageType.SafetyFeature
        }))
      : [];

    return featureImages
      .concat(imperfectionImages)
      .concat(exteriorImages)
      .concat(safetyFeatureImages);
  }, [
    featuresRaw,
    imperfectionsRaw,
    includeSafetyFeatures,
    safetyFeatures,
    spins
  ]);
}
